<template>
  <div class="address-data">
    <div class="mb-3 mt-3 p-3 p-lg-5">
      <loading :active.sync="is_loading"></loading>
      <div class="form-group" v-if="!new_address && has_address">
        <!--ul id="address-list" class="list-group">
					<li class="list-group-item" v-for="direccion in addresses" >
						<b-form-radio name="direcciones" @change="selectingAddress(direccion)">
							<address class="d-flex w-100 justify-content-between text-capitalize">
								<p>{{ direccion.street }} {{ direccion.no_ext }}, {{ direccion.suburb }}, {{ direccion.municipality }}, {{ direccion.state }}, {{ direccion.cp }},
								{{ direccion.btw_streets }}, {{ direccion.references }}</p>
							</address>
						</b-form-radio>
					</li>
				</ul-->
      </div>
      <div class="form-group">
        <div class="container">
          <div>
            <h2 v-if="susbscriptionMessage">{{ susbscriptionMessage }}</h2>
            <h2 v-else>Elige una dirección de envío</h2>
            <p>
              Puedes actualizar alguna de las direcciones antes registradas para
              que tu envío llegue sin problemas
            </p>
            <div class="row">
              <div
                v-for="direccion in addresses"
                class="col-12 col-lg-4 my-2 my-lg-4"
              >
                <div class="card  p-3 p-lg-4">
                  <address
                    class="d-flex w-100 justify-content-between text-capitalize"
                  >
                    <p>
                      {{ direccion.street }} {{ direccion.no_ext }},
                      {{ direccion.suburb }}, {{ direccion.state }},
                      {{ direccion.cp }}, {{ direccion.btw_streets }},
                      {{ direccion.references }}
                    </p>
                  </address>
                  <b-button
                    style="background: #aa0e47; color: #fff"
                    class="btn w-100"
                    @click="newSelectedAddress(direccion)"
                    >Seleccionar</b-button
                  >
                  <b-button
                    class="btn btn-light w-100 mt-3"
                    v-b-modal.address-modal
                    @click="showAddressModal(direccion)"
                    >Editar</b-button
                  >
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <h5>¿No tienes una direcci&oacute;n registrada?</h5>
          <br />
          <b-button
            type="button"
            class="btn text-light"
            style="background: #0f182b; font-weight: bold"
            @click="directionType(2)"
            >REGISTRA UNA NUEVA DIRECCI&Oacute;N</b-button
          >
        </div>
        <!--ul class="nav nav-tabs"-->
        <!-- 				<label for="c_ship_different_address" class="text-black" data-toggle="collapse" href="#ship_different_address" role="button" aria-expanded="true" aria-controls="ship_different_address"><input type="checkbox" value="1" v-model="current_address"> Misma dirección  </label>
				<label for="c_ship_different_address" class="text-black" data-toggle="collapse" href="#ship_different_address" role="button" aria-expanded="false" aria-controls="ship_different_address"><input type="checkbox" value="2" v-model="new_address"> Dirección diferente</label> -->
      </div>
      <!-- .form-group -->
      <!-- new adress -->
      <div v-if="new_address">
        <div class="form-group row">
          <div class="col-md-12">
            <label for="c_address" class="text-black"
              >Campos obligatorios <span class="text-danger">*</span></label
            >
          </div>
        </div>
        <!-- .form-group -->

        <div class="form-group row">
          <div class="col-md-6">
            <input
              type="text"
              class="form-control"
              v-model="address.cp"
              placeholder="Código postal"
            />
          </div>
          <div class="col-md-6">
            <select
              class="form-control"
              id="state_id"
              v-model="address.state_id"
            >
              <option value="">.: Selecciona Estado :.</option>
              <option v-for="state in states" :value="state.id">
                {{ state.name }}
              </option>
            </select>
          </div>
        </div>
        <!-- .form-group -->

        <div class="form-group">
          <select class="form-control" id="suburb_id" v-model="address.suburb">
            <option value="">.: Selecciona Colonia o Asentamiento :.</option>
            <option
              v-for="suburb in suburbs"
              :value="suburb.d_asenta"
              :key="suburb.d_asenta"
            >
              {{ suburb.d_asenta }}
            </option>
          </select>
        </div>
        <!-- .form-group -->

        <div class="form-group">
          <input
            type="text"
            class="form-control"
            placeholder="Delegacion o Municipio"
            v-model="address.municipality"
          />
        </div>
        <!-- .form-group -->

        <div class="form-group row">
          <div class="col-md-12">
            <input
              type="text"
              class="form-control"
              v-model="address.street"
              placeholder="Calle"
            />
          </div>
        </div>
        <!-- .form-group -->

        <div class="form-group row">
          <div class="col-md-6">
            <input
              type="text"
              class="form-control"
              v-model="address.no_int"
              placeholder="Número interior"
            />
          </div>
          <div class="col-md-6">
            <input
              type="text"
              class="form-control"
              v-model="address.no_ext"
              placeholder="Número exterior"
            />
          </div>
        </div>
        <!-- .form-group -->

        <div class="form-group row">
          <div class="col-md-12">
            <input
              type="text"
              class="form-control"
              v-model="address.btw_streets"
              placeholder="Entre calles"
              required
            />
          </div>
        </div>
        <!-- .form-group -->

        <div class="form-group row">
          <div class="col-md-12">
            <input
              type="text"
              class="form-control"
              v-model="address.references"
              placeholder="Referencias"
            />
          </div>
        </div>
        <!-- .form-group -->

        <div class="form-group row">
          <div class="mx-2 form-check">
            <input
              type="radio"
              id="customRadioInline1"
              name="customRadioInline1"
              class="form-check-input"
              v-model="address_type"
              value="1"
            />
            <label class="form-check-label" for="customRadioInline1"
              >Para entregar en el buzón de tu casa</label
            >
          </div>
          <div class="mx-2 form-check">
            <input
              type="radio"
              id="customRadioInline2"
              name="customRadioInline1"
              class="form-check-input"
              v-model="address_type"
              value="2"
            />
            <label class="form-check-label" for="customRadioInline2"
              >Alguien deberá firmar de recibido</label
            >
          </div>
        </div>
        <!-- .form-group -->
        <button
          class="btn btn-blue btn-sm"
          type="button"
          v-if="!is_registered"
          @click="saveAddress"
        >
          Guardar y continuar
        </button>
      </div>
    </div>
    <AddressModal :address="selectedAddress" :states="states"></AddressModal>
  </div>
  <!-- .address-data -->
</template>

<script>
import Loading from "vue-loading-overlay";
import AddressModal from "@/components/AddressModal";
const axios = require("axios");

export default {
  name: "AddressForm",
  props: ["showT", "changeV","susbscriptionMessage"],
  components: {
    Loading,
    AddressModal,
  },
  data() {
    return {
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      token_sepomex: process.env.VUE_APP_API_SEPOMEX_TOKEN,
      has_address: false,
      is_loading: true,
      new_address: false,
      is_registered: false,
      address_type: 2,
      addresses: [],
      states: [],
      suburbs: [],
      selected: null,
      address: {
        id: "",
        cps_sepomex_id: "",
        state: "",
        state_id: "",
        street: "",
        suburb: "",
        btw_streets: "",
        references: "",
        no_int: "",
        no_ext: "",
        municipality: "",
        cp: "",
        address_type_id: "",
      },
      selectedAddress: null,
    };
  },
  mounted() {
    if ($cookies.get("ctoken")) {
      console.info("Cargando la direccion desde el componente");
      this.getSubscriberAddress();
      this.getStates();
    }
  },
  watch: {
    "address.cp": function (newVal, oldVal) {
      if (newVal != undefined && newVal.length > 4) {
        axios({
          method: "GET",
          url: this.api_url + "/cpssepomex/cp/" + newVal,

          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + $cookies.get("utoken"),
          },
        })
          .then((response) => {
            this.suburbs = response.data;
            // console.log(this.suburbs);
            this.address.suburb = this.suburbs[0].d_asenta;
            this.address.cp = this.suburbs[0].d_codigo;
            this.address.municipality = this.suburbs[0].d_mnpio;
            this.setAddressData(this.address);
          })
          .catch((error) => {
            console.error(error);
            this.$snotify.error("No hay información del CP");
          });
      }
    },
    new_address: function (newVal, oldVal) {
      if (newVal) {
        this.cleanAddressData();
      } else {
        this.getSubscriberAddress();
      }
    },
    // selected: function (newVal, oldVal) {
    //   console.info("Dirección seleccionada");
    //   console.info(newVal);
    //   this.selectingAddress(newVal);
    // },
  },
  methods: {
    newSelectedAddress: function (address) {
      this.$snotify.success("Dirección seleccionada");
      console.log(address);
      this.selectingAddress(address);
      this.$emit("changeV", !this.showT);
    },
    showAddressModal: function (address) {
      console.info("Direccion seleccionada: " + address.id);
      console.info(address);
      this.selectedAddress = address;
    },
    saveAddress: function () {
        if (this.validateAddressData()){
            this.registerAddress();
        }else{
            this.$snotify.error("Faltan datos de tu dirección");
        }
    },
    registerAddress: function () {
      this.is_loading = true;
      if (this.new_address) {
        axios({
          method: "POST",
          url: this.api_url + "/address",
          data: {
            subscriber_id: $cookies.get("uidmmkg"),
            state_id: this.address.state_id,
            address_type_id: this.address_type,
            cps_sepomex_id: 0,
            street: this.address.street,
            suburb: this.address.suburb,
            btw_streets: this.address.btw_streets,
            references: this.address.references,
            no_int: this.address.no_int,
            no_ext: this.address.no_ext,
            state: this.address.state,
            municipality: this.address.municipality,
            cp: this.address.cp,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + $cookies.get("utoken"),
          },
        })
          .then((response) => {
            console.info("Datos de respuesta de registro de direccion");
            console.info(response);
            if (response.data.status == false) {
                this.is_loading = false;
                this.$snotify.error("Hubo un error en el registro de direccion");
            } else {
                this.is_loading = false;
                this.address = response.data;
                // this.$snotify.info("Se registró la direccion");
                this.setAddressData(this.address);
                this.is_registered = true;
                this.addresses.push(this.address);
                this.newSelectedAddress(this.address);
            }
          })
          .catch((error) => {
            this.is_loading = false;
            console.error(error);
          });
      }
    },
    directionType: function (type) {
      switch (type) {
        case 1:
          this.current_address = true;
          this.new_adress = false;
          break;

        case 2:
          this.current_address = false;
          this.new_address = true;
          break;

        default:
          this.current_address = true;
          this.new_adress = false;
          break;
      }
    },
    getStates: function () {
      axios({
        method: "GET",
        url: this.api_url + "/state",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("ctoken"),
        },
      })
        .then((response) => {
          this.states = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getStateName: function (address) {
      console.info("Funcion para obtener el nombre del estado");
      console.info(address.state_id);
      axios({
        method: "GET",
        url: this.api_url + "/state/" + address.state_id,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("ctoken"),
        },
      })
        .then((response) => {
          address.state = response.data.name;
        })
        .catch((error) => {
          console.error(error);
        });
      return address;
    },
    getSubscriberAddress: function () {
      if ($cookies.get("uidmmkg")) {
        axios({
          method: "GET",
          url: this.api_url + "/address/subscriber/" + $cookies.get("uidmmkg"),
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + $cookies.get("ctoken"),
          },
        })
          .then((response) => {
            if (response.data.length > 0) {
              let scope = this;
              this.has_address = true;
              console.info("Direccion(es) del usuario: ");
              console.info(response.data);

              $.each(response.data, function (key, value) {
                console.info("Datos de la direccion");
                console.info(value);
                let address = scope.parseAddress(value);
                if (address) {
                  // address = scope.getCP(address);
                  address = scope.getStateName(address);

                  scope.addresses.push(address);
                }
              });
            }
            this.is_loading = false;
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.is_loading = false;
      }
    },
    parseAddress: function (data) {
      console.info("Parseando los datos");
      var address = {};
      if (data) {
        address.id = data.id;
        address.cps_sepomex_id = 0;
        address.state_id = data.state_id;
        address.street = data.street;
        address.suburb = data.suburb;
        address.btw_streets = data.btw_streets;
        address.references = data.references;
        address.no_int = data.no_int;
        address.no_ext = data.no_ext;
        address.state = data.state;
        address.municipality = data.municipality;
        address.cp = data.cp;

        return address;
      } else {
        return false;
      }
    },
    setAddressData: function (data) {
      console.info("En la funcion de setear address");
      console.info(data);
      if (data) {
        this.$emit("update", data);
      } else {
        this.$emit("update", {});
      }
    },
    // getCP: function (address) {
    //   console.info("Buscando el CP para la direccion");
    //   console.info(address);
    //   if (address.cp == "" || !address.cp) {
    //     axios({
    //       method: "GET",
    //       url:
    //         "https://api.copomex.com/query/search_cp_advanced/Ciudad de Mexico?colonia=" +
    //         address.suburb,
    //     })
    //       .then((response) => {
    //         console.info(response);
    //         if (!response.data.error) {
    //           address.cp = response.data.response.cp[0];
    //         }
    //       })
    //       .catch((error) => {
    //         console.error(error);
    //       });
    //   }
    //   return address;
    // },
    cleanAddressData: function () {
      this.setAddressData(false);
    },
    selectingAddress: function (address) {
      console.info("Seleccionando direccion");
      console.info(address);
      //event.target.classList.add('active');
      this.setAddressData(address);
    },
      validateAddressData: function(){
          if (this.address.cp != ''
              && this.address.state_id != 0
              && this.address.municipality != ''
              && this.address.suburb != ''
          && this.address.street != ''
          && this.address.no_ext != ''
          && this.address.btw_streets != ''
          && this.address.references != ''){
              return true;
          }

          return false;
      }
  },
};
</script>

<style scoped>
.border-shadow {
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.15);
}
.card {
    background-color: #fcfcff;
    border: none;
}
.btn.btn-secondary {
    background-color: #ffffff;
    border: 1px solid #f1f1f1;
    color: #000;
}
</style>
